import Vue from 'vue'
import Router from 'vue-router'
import Login from './views/Login.vue'
import '../public/reset.scss'
import Auditing from './views/Auditing.vue'
Vue.use(Router)

// 解决同一路由连续点击出现的bug
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login
    },
    {
      path: '/home',
      name: '',
      component: resolve => require(['@/components/layout'], resolve),
      children: [
        {
          path: '/tag',
          name: 'tag',
          component: resolve => require(['./views/tag'], resolve),
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: '/zhaopin',
          component: () => import('@/views/zhaopin'),
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        // {
        //   path: "/hirelist",
        //   component: resolve => require(["./views/Hirelist.vue"], resolve),
        //   // meta: ["二级菜单", "招聘列表"]
        //   meta: {
        //     requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        //   }
        // },
        {
          path: '/tab',
          component: resolve => require(['./views/Tab.vue'], resolve),
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: '/staff',
          component: resolve => require(['./views/Staff.vue'], resolve),
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: '/yuangong',
          component: () => import('@/views/staff/index'),
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: '/backup',
          component: () => import('@/views/backup/index'),
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        // {
        //   path: '/backup/:id',
        //   component: () => import('@/views/backup/#file-detail'),
        //   meta: {
        //     requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
        //   }
        // },
        {
          path: '/backup/email/:id',
          component: () => import('@/views/backup/#mail-detail'),
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: '/backup/email/list/:id/:dir',
          component: () => import('@/views/backup/#mail-detail-list'),
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: '/filebackup',
          component: () => import('@/views/filebackup/index'),
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: '/filebackup/:id',
          component: () => import('@/views/filebackup/#file-detail'),
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: '/staff/:id',
          component: () => import('@/views/staff/edit'),
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: '/publish',
          component: () => import('@/views/post/index'),
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: '/addstaff',
          component: resolve => require(['./views/Addstaff.vue'], resolve),
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: '/resume',
          component: () => import('@/views/zhaopin/#jianli.vue'),
          // meta: ["三级菜单", "查看简历"]
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: '/neitui',
          component: () => import('@/views/neitui/index'),
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: '/changjing',
          component: () => import('@/views/channel/index'),
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: '/changjing/edit/:id',
          component: () => import('@/views/channel/edit'),
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: '/changjing/edit_column',
          component: () => import('@/views/channel/edit-column'),
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: '/changjing/edit_contact/:id',
          component: () => import('@/views/channel/edit-contact'),
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: '/email',
          component: () => import('@/views/mail/index'),
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: '/email/receive_list',
          component: () => import('@/views/mail/#receive-list.vue'),
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: '/email/status_list',
          component: () => import('@/views/mail/#status-list.vue'),
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: '/email/template',
          component: () => import('@/views/mail/#template.vue'),
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: '/message',
          component: () => import('@/views/message/list'),
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: '/evaluation',
          component: () => import('@/views/evaluation/index'),
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: '/evaluation/edit-prize',
          component: () => import('@/views/evaluation/edit-prize'),
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: '/evaluation/detail',
          component: () => import('@/views/evaluation/detail'),
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: '/project',
          component: () => import('@/views/project/project-lists'),
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: '/project/project-edit',
          component: () => import('@/views/project/project-edit'),
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: '/record',
          component: () => import('@/views/record/list'),
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: '/mobile/',
          component: () => import('@/views/mobile/index'),
          meta: {
            requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
          }
        },
        {
          path: '/mobile/detail/:id',
          component: () => import('@/views/mobile/detail'),
          meta: {
            requireAuth: false // 添加该字段，表示进入这个路由是需要登录的
          }
        }
      ]
    },
    {
      path: '/changjing/detail/:id',
      component: () => import('@/views/channel/detail'),
      meta: {
        requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
      }
    },
    {
      path: '/review/operable/:id',
      name: 'review-operable',
      component: () => import('@/views/zhaopin/review'),
      meta: {
        requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
      }
    },
    {
      path: '/review/:id',
      name: 'review',
      component: () => import('@/views/zhaopin/review'),
      meta: {
        requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
      }
    },
    {
      path: '/auditing',
      name: 'auditing',
      component: Auditing,
      meta: {
        requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
      }
    },
    {
      path: '/look',
      name: 'look',
      component: resolve => require(['./views/Look.vue'], resolve),
      meta: {
        requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
      }
    },
    {
      path: '/details',
      name: 'details',
      component: resolve => require(['./views/Details.vue'], resolve),
      meta: {
        requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
      }
    }
  ]
})
